import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetAgentQuery,
  GetComposerAgentsParams,
  SpaceEnvironmentsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: GetComposerAgentsParams | GetAgentQuery
  shortErrorMessage?: string
  children?: (environment: SpaceEnvironmentsResponse[]) => ReactElement
  onSuccess?: (data: SpaceEnvironmentsResponse[]) => void
  onError?: (error: Error) => void
}

const GetAiEnvironmentsComposerRequest = ({
  params,
  shortErrorMessage,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/agents`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetAiEnvironmentsComposerRequest
